import { Component, EventEmitter, Input, Output } from '@angular/core';

// Trip registration modal hosting the trips component.
@Component({
  selector: 'trip-modal',
  templateUrl: './trip-modal.component.html',
})
export class TripModalComponent {
  @Input() isOpen: boolean = false;

  @Output() closed = new EventEmitter<void>();
}
